import React from 'react';
import { isNumber } from 'lodash';
import { Box, Typography } from '@mui/material';

import { resumeFileUrl } from '@constants';
import {
  ICandidateDetails,
  ICandidateRanking,
  IPositionCandidateTestTask,
} from '@types';
import { RankingValue } from 'components/common/RankingValue/RankingValue';
import { ScoreCell } from 'components/common/ScoreCell/ScoreCell';
import { Fact } from './DetailFacts';
import { OpenResumeButton } from './OpenResumeButton';

export const AssessmentFacts: React.FC<{
  ranking: ICandidateRanking | null;
  testTask: IPositionCandidateTestTask | null;
  children?: React.ReactNode;
}> = ({ ranking, testTask, children }) => (
  <Box display="flex" flexWrap="wrap" gap={4}>
    <Fact label="Technical ranking">
      <RankingValue value={ranking?.technicalInterview ?? null} />
    </Fact>
    <Fact label="Soft skills">
      <RankingValue value={ranking?.softSkills ?? null} />
    </Fact>
    <Fact label="Test task">
      <ScoreCell testTask={testTask} label="test task" />
    </Fact>
    {children}
  </Box>
);

export const AssessmentBlock: React.FC<{ data: ICandidateDetails }> = ({
  data,
}) => {
  const testTask = data.testTasks?.[0];

  return (
    <AssessmentFacts
      ranking={data.ranking}
      testTask={
        testTask
          ? {
              score: testTask.score,
              status: testTask.status,
              isPending: testTask.isPending,
            }
          : null
      }
    >
      {Boolean(data.profile?.englishLevel) && (
        <Fact label="English">
          <Typography variant="body1">{data.profile?.englishLevel}</Typography>
        </Fact>
      )}
      {isNumber(data.profile?.experience) && (
        <Fact label="Experience">
          <Typography variant="body1">
            {data.profile?.experience} years
          </Typography>
        </Fact>
      )}
      {Boolean(data.profile?.resumeName) && (
        <Fact label="Full resume">
          <OpenResumeButton href={resumeFileUrl(data.profile!.resumeName!)} />
        </Fact>
      )}
    </AssessmentFacts>
  );
};
